export default __webpack_public_path__ + "static/media/web_desa.6fae1a7a.png";